import React from 'react'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'

import AuthenticatedNavigation from './AuthenticatedNavigation'
import StikisLogoTiny from 'images/stikis_logo-img_only-small.png'

export default function NoPageMenu() {
  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
        }}
      >
        <IconButton
          edge='start'
          aria-label='home page'
          sx={{
            paddingRight: '2px',
            color: 'white',
          }}
          size='large'
        >
          <a href='/app/welcome'>
            <img src={StikisLogoTiny} id='stikisLogoTiny' alt='Stikis logo' />
          </a>
          <Typography
            variant='h1'
            sx={{
              fontWeight: 900,
              fontSize: '2rem',
            }}
          >
            stikis
          </Typography>
        </IconButton>
      </Box>
      <AuthenticatedNavigation />
    </React.Fragment>
  )
}
